import { ClientRemovalsRepository } from "@domain/repositories/ClientRemovalsRepository";
import { HttpClient } from "@data/api/HttpClient";
import { Client } from "@domain/models/Client";

export class HttpClientRemovalsRepository implements ClientRemovalsRepository {
  private readonly baseUrl = `${process.env.REACT_APP_API_URL}/client_removals`;

  constructor(private readonly httpClient: HttpClient) {}

  async getClientRemovals(clientId: Client["id"]) {
    return this.httpClient
      .request({
        method: "GET",
        url: `${this.baseUrl}/${clientId}`,
      })
      .then((response) => {
        return response.data;
      });
  }
}
